import React from "react";
import "./style.less";

const PdfFile = ({ url }) => (
  <div className="pdfFileWrapper">
    <object
      data={url}
      type="application/pdf"
      width="100%"
      height="100%"
      style={{ borderRadius: "20px" }}
    >
      <p style={{ textAlign: "center", padding: "20px" }}>
        Unable to display PDF.{" "}
        <a href={url} target="_blank" rel="noopener noreferrer">
          Click here to view/download
        </a>
      </p>
    </object>
  </div>
);

export default PdfFile;